import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import style from './MachineCard.module.css';

const MachineCard = ({ item, index }) => {
    // 기기가 키오스크인지 확인
    const isKiosk = item.machineType === 'KIOSK';
    
    return (
        <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    <div className={`${style.container} ${isKiosk ? style.kioskContainer : ''}`}>
                        <p>No. {item.orderNo}</p>
                        {
                            item.image &&
                            <div className={style.imageContainer}>
                                <img src={`data:image/png;base64,${item.image}`} alt={item.vendingName || '기기 이미지'} />
                            </div>
                        }
                        <div className={style.textContent}>
                            <div className={style.nameContainer}>
                                <p>{item.vendingName || '미등록 기기'}</p>
                                {isKiosk && <span className={style.kioskBadge}>키오스크</span>}
                            </div>
                            {isKiosk && <p>ID : {item.deviceCode || '-'}</p>}
                            {item.location && <p>위치 : {item.location}</p>}
                        </div>
                    </div>
                </div>
            )}
        </Draggable>
    );
};

export default MachineCard;